import {Singleton} from "@/patterns/Singleton";
import {StorageInterface} from "@/models/facade/storage/StorageInterface";
import {LocalStorageKeyEnum} from "@/models/enum/LocalStorageKeyEnum";
import {SessionStorageKeyEnum} from "@/models/enum/SessionStorageKeyEnum";

export class SessionStorage extends Singleton implements StorageInterface {
    get(key: LocalStorageKeyEnum|SessionStorageKeyEnum, defaultValue?: any): any {
        return sessionStorage.getItem(key.toString()) || defaultValue;
    }

    remove(key: LocalStorageKeyEnum|SessionStorageKeyEnum): void {
        sessionStorage.removeItem(key.toString());
    }

    set(key: LocalStorageKeyEnum|SessionStorageKeyEnum, value: any): void {
        sessionStorage.setItem(key.toString(), value);
    }
}
